export default __webpack_public_path__ + "static/media/gen-ext-defr.8c3c6a88.png";